{
  "GQL_ENDPOINT": "https://gql.hashnode.com/",
  "version": "0.0.6"
}